import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { BellRing, Clock } from 'lucide-react';
import { INTERVALOS } from './vigilanciaUtils';

const FILAS = [
  { k: 'diario', t: 'Límite diario', d: 'Disponible del límite diario' },
  { k: 'mensual', t: 'Límite mensual', d: 'Disponible del límite mensual' },
  { k: 'saldo', t: 'Saldo disponible', d: 'Total disponible en la billetera' },
];

const UmbralRow = ({ fila, valor, onChange }) => (
  <div className="grid grid-cols-12 items-center gap-2 py-2.5 border-b border-slate-100 last:border-0">
    <div className="col-span-12 sm:col-span-4">
      <p className="text-sm font-semibold text-slate-800">{fila.t}</p>
      <p className="text-[11px] text-slate-500">{fila.d}</p>
    </div>
    <div className="col-span-7 sm:col-span-5 relative">
      <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400">≤ $</span>
      <Input
        type="number" min="0" step="any" placeholder="monto" value={valor.monto}
        onChange={(e) => onChange({ ...valor, monto: e.target.value })}
        className="pl-9 h-9 tabular-nums" data-testid={`regla-${fila.k}-monto`}
      />
    </div>
    <div className="col-span-5 sm:col-span-3 relative">
      <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400">≤</span>
      <Input
        type="number" min="0" max="100" step="any" placeholder="%" value={valor.pct}
        onChange={(e) => onChange({ ...valor, pct: e.target.value })}
        className="pl-6 pr-7 h-9 tabular-nums" data-testid={`regla-${fila.k}-pct`}
      />
      <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400">%</span>
    </div>
  </div>
);

export const ReglasForm = ({ value, onChange }) => {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="space-y-4" data-testid="vigilancia-reglas-form">
      <div className="flex flex-wrap items-end gap-3">
        <div className="space-y-1.5">
          <Label className="flex items-center gap-1.5 text-xs text-slate-600"><Clock size={13} /> Frecuencia de chequeo en Waya</Label>
          <Select value={String(value.intervalo_min)} onValueChange={(v) => set({ intervalo_min: Number(v) })}>
            <SelectTrigger className="w-[200px] h-9" data-testid="regla-intervalo-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {INTERVALOS.map((i) => <SelectItem key={i.v} value={String(i.v)}>{i.l}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs text-slate-600">Saldo de referencia (para el %)</Label>
          <Input
            type="number" min="0" step="any" placeholder="auto: 1er chequeo" value={value.saldo_referencia}
            onChange={(e) => set({ saldo_referencia: e.target.value })}
            className="w-[200px] h-9 tabular-nums" data-testid="regla-saldo-referencia"
          />
        </div>
      </div>
      <div className="rounded-xl border border-slate-200 bg-white px-4 py-1.5">
        <p className="flex items-center gap-1.5 pt-2 pb-1 text-xs font-semibold uppercase tracking-[0.1em] text-teal-700">
          <BellRing size={13} /> Alertar cuando baje a
        </p>
        {FILAS.map((f) => (
          <UmbralRow
            key={f.k} fila={f} valor={value.reglas[f.k]}
            onChange={(u) => set({ reglas: { ...value.reglas, [f.k]: u } })}
          />
        ))}
      </div>
      <p className="text-[11px] text-slate-500">
        Podés usar monto, porcentaje o ambos (alcanza con que se cumpla uno). Dejá vacío para no alertar.
      </p>
    </div>
  );
};

export default ReglasForm;
